/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateExpenseCategoryInput = {
    name?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type createExpenseCategoryMutationVariables = {
    input: CreateExpenseCategoryInput;
};
export type createExpenseCategoryMutationResponse = {
    readonly createExpenseCategory: {
        readonly expenseCategory: {
            readonly node: {
                readonly id: string;
                readonly name: string | null;
                readonly canDelete: boolean | null;
            } | null;
        } | null;
    } | null;
};
export type createExpenseCategoryMutation = {
    readonly response: createExpenseCategoryMutationResponse;
    readonly variables: createExpenseCategoryMutationVariables;
};



/*
mutation createExpenseCategoryMutation(
  $input: CreateExpenseCategoryInput!
) {
  createExpenseCategory(input: $input) {
    expenseCategory {
      node {
        id
        name
        canDelete
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateExpenseCategoryInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateExpenseCategoryPayload",
    "kind": "LinkedField",
    "name": "createExpenseCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ExpenseCategoryTypeEdge",
        "kind": "LinkedField",
        "name": "expenseCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ExpenseCategory",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canDelete",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createExpenseCategoryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createExpenseCategoryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createExpenseCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation createExpenseCategoryMutation(\n  $input: CreateExpenseCategoryInput!\n) {\n  createExpenseCategory(input: $input) {\n    expenseCategory {\n      node {\n        id\n        name\n        canDelete\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'e3661246bb7bd67f69df678fd68acf3f';
export default node;
